/**
* 头部菜单
*/
<template>
  <div class="nav-tem">
    <div @click="opencity" class="city" style="margin-top:1%;margin-right:10px" mode="horizontal">
      <div>
        <div v-if="name!=''">{{name}} <i class="el-icon-arrow-down" v-if="unti==true"></i> <i class="el-icon-arrow-up" v-else></i></div>
        <div v-else-if="path=='/home/home'||path=='/home/mouth'||path=='/home/mouth_ct'">全国 <i class="el-icon-arrow-down" v-if="unti==true"></i> <i class="el-icon-arrow-up" v-else></i></div>
        <div v-else>北京 <i class="el-icon-arrow-down" v-if="unti==true"></i> <i class="el-icon-arrow-up" v-else></i></div>
        
      </div>
    </div>
    <div class="ii">
      <i class="el-icon-tuichu" style="cursor: pointer;" @click="exit" ></i>
    </div>
    
    <!-- <el-button @click="exit" style="margin-top:10px;margin-right:37px">退出登录</el-button> -->
    <!-- <el-menu :default-active="activeIndex" class="el-menu-demo" mode="horizontal" @select="handleSelect"  background-color="#282d42">
      <el-menu-item index="1" @click="exit">退出登录</el-menu-item>
    </el-menu> -->
    <el-dialog
      :visible.sync="detailsFormVsible"
      class="edit-dialog"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :before-close="handleClose">
      <el-form class="from">
        <el-form-item>
          <div class="letter">
            <span v-for="(item) in zhimu"  @click="xuanz(item)" :key="item" :class='item==letter?"letter1":""'>
            {{item}}
            </span>
          </div>
          
        </el-form-item>
        <el-form-item>
          <div v-show="path=='/home/home'||path=='/home/mouth'||path=='/home/mouth_ct'">全国:<span class="citry" @click="city2({id:'',name:'全国'})"  >全国</span></div>
          <span v-for="(item,index1) in city1" :key="index1">
            {{index1}}：
            <span >
              <span v-for="(item2,index) in item" :key="index" class="citry">
                <span @click="city2(item2)" :class='c_id==item2.id?"c_id":""'>{{item2.name}}</span>
              </span> <br>
            </span>
          </span>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>
<script>
import { getcitys} from "../api/ranking";
export default {

  name: "navcon",
  data() {
    return{
      path:'',
      name:'',
      singers:[],
      zhimu:[],
      city:[],
      city1:[],
      city3:[],
      city4:[],
      letter:'',
      c_id:'',
      unti:true,
      activeIndex: '1',
      detailsFormVsible:false,
      zong:[],
      ss:'',
    }
  },
  // 创建完毕状态(里面是操作)
  created() {
    this.$root.Bus.$on("path",value=>{
     this.path=value
    })
  },

  methods:{
    city2(item){
      console.log(item);
      this.c_id=item.id
      this.name=item.name
      this.$root.Bus.$emit('city_id',item.id)
      this.detailsFormVsible=false
      this.unti=true
    },
    handleClose(){
      this.detailsFormVsible=false
      this.unti=true
    },
    opencity(){
      this.unti=false
      this.detailsFormVsible=true
    },
    handleSelect(key, keyPath) {
      console.log(key, keyPath);
    },
    getcity(){
      getcitys().then(res=>{
        if (res.errno === 0) {
          for(var i in res.data){
            var obj={
              id:i,
              name:res.data[i].name,
              zimu:res.data[i].zimu
            }
            this.city.push(obj)
          }
          let hashMao1=this.city.sort((a,b)=>{
             return a["zimu"].localeCompare(b["zimu"])
          })
          this.zong=hashMao1
          let hashMap=hashMao1.reduce((hashMap,next)=>{
            hashMap[next.zimu]=hashMap[next.zimu]?[...hashMap[next.zimu],next]:[next];
            return hashMap
          },{})
          let hashMap1=hashMao1.reduce((hashMap,next)=>{
            hashMap[next.zimu]=hashMap[next.zimu]?[...hashMap[next.zimu],next]:[next];
            return hashMap
          },{})
          this.zhimu.push("全部")
          for(var j in hashMap){
            this.zhimu.push(j)
          }
          this.city1=JSON.parse(JSON.stringify(hashMap));
          // if (this.$route.path=='/home/home'||this.$route.path=='/home/mouth'||this.$route.path=='/home/mouth_ct') {
          //   this.city1["A"].push({id:'',name:'全国',zhimu:''})
          // }
          this.city3=hashMap

          this.city4=hashMap1
          } else if (res.errno === 401) {
            this.$store.dispatch('LogOut').then(() => {
              location.reload() // 为了重新实例化vue-router对象 避免bug
            })
          } else {
            this.$message.error(res.data)
          }
      })
    },

    xuanz(zhimu){
      this.letter=zhimu
      for(var i in this.city3){
        if (i==zhimu) {
          var obj={
            "城市":this.city3[i]
          }
        this.city1=obj
        }
      }
      if (zhimu=="全部") {
        this.city1=this.city4
      }
    },
    // 退出登录
    exit() {
      this.$confirm('退出登录, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.$store.dispatch('LogOut').then(() => {
            location.reload() // 为了重新实例化vue-router对象 避免bug
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消'
          })
        })
    },
    
  },
  mounted() {
    this.getcity()
  },
};
</script>
<style scoped>
.ii i {
    color:#888c9c;
    font-size: 30px;
    margin-top:22%;
    margin-right: 30px;
  }
  .c_id{
    color: #4087f7;
  }
.letter span{
    cursor: pointer;
    width: 34px;
    text-align: center;
    float: left;
    font-size: 14px;
    display: inline-block;
    font-size: #000;
    margin: 8px;
    border: 1px solid #e8e8e8;
    
}
.letter span:hover{
    cursor: pointer;
    width: 34px;
    text-align: center;
    float: left;
    font-size: 14px;
    display: inline-block;
    font-size: #fff;
    color: #fff;
    margin: 8px;
    border: 1px solid #e8e8e8;
    background: #4087f7;
}
.letter1{
    cursor: pointer;
    width: 34px;
    text-align: center;
    float: left;
    font-size: 14px;
    display: inline-block;
    font-size: #000;
    margin: 8px;
    border: 1px solid #e8e8e8;
    color: #fff;
    background: #4087f7;
}
.citry{
  /* display: inline-block; */
    height: 26px;
    padding: 0 7px;
    font-weight: 400;
    line-height: 30px;
    font-size: 14px;
    cursor: pointer;
}
.citry:hover{
  /* display: inline-block; */
    height: 26px;
    padding: 0 7px;
    font-weight: 400;
    line-height: 30px;
    font-size: 14px;
    cursor: pointer;
    color: #4087f7;
}

.city{
  cursor: pointer;
  color: #fff;
}
.nav-tem{
  display: flex;
  justify-content:flex-end;
  background: #1f2334;
}
.el-menu-item{
  float: right;
  width: 100px;
  height: 40px;
  border: 1px solid #666666!important;
  text-align: center;
  border-radius: 6px;
  color: #666666;
  margin-top: 10px;
  margin-right: 20px;
  line-height: 40px;
}
.el-menu--horizontal>.el-menu-item.is-active {
  color: #666666;
}
  .el-menu.el-menu--horizontal{
    height: 60px;
  }
  .edit-dialog >>> .el-dialog {
  width: 47%;
}
.from>>>.el-form-item__content{
  line-height: 20px;
}
</style>
<style>
/*.m-pop .el-menu--popup {*/
/*  min-width: 168px !important;*/
/*  text-align: center !important;*/
/*  padding: 0;*/
/*}*/
/*.m-pop.el-menu--horizontal .el-menu-item:not(last-child) {*/
/*  text-align: center !important;*/
/*  !* width: 168px !important; *!*/
/*  !* background-color: #f31010 !important; *!*/
/*  border-bottom: 1px solid #409EFF;*/
/*}*/
/*.m-pop.el-menu--horizontal .el-menu-item:last-child {*/
/*  border-bottom: 1px solid transparent;*/
/*}*/
/*.m-pop.el-menu--horizontal .el-menu-item:not(.is-disabled):hover {*/
/*  background-color: #fbfbfb !important;*/
/*  color: rgb(128, 128, 128) !important;*/
/*}*/
/*.m-alert .el-submenu__icon-arrow.el-icon-arrow-down {*/
/*  display: none;*/
/*}*/

</style>



// WEBPACK FOOTER //
// src/components/navcon.vue